const selectors = {
    featuredCollection: '[data-section-type="featured-collection"]',
    productList: '.product-list',
    productItem: '.product-item'
}

function sortNodesByOrder(nodes) {
    if (!(nodes) || nodes.length < 1) {
        console.warn('sortNodesByOrder(nodes): (nodes) || nodes.length < 1');
        return;
    }
    const sortedArray = [];
    nodes.forEach((el) => {
        const order = el.order - 1;
        sortedArray[order] = el.productNode;
    });
    return sortedArray;
}

function getProductsWithOrder() {
    const products = document.querySelectorAll(`${selectors.featuredCollection} ${selectors.productItem}`);
    if (!(products) || products.length < 1) {
        console.warn('getProductsWithOrder(): (products) || products.length < 1');
        return;
    }
    if (products[0].dataset.order < 1) {
        console.warn('getProductsWithOrder(): products[0].dataset.order < 1');
        return;
    }
    const formattedList = [];
    products.forEach(p => {
        formattedList.push({
            order: p.dataset.order,
            productNode: p
        });
    });
    return formattedList;
}

function replaceNodesInsideContainer(containerSelector, nodeList) {
    if (!(nodeList) || nodeList.length < 1) {
        console.warn('replaceNodesInsideContainer(containerSelector, nodeList): (nodeList) || nodeList.length < 1');
        return;
    }
    if (typeof containerSelector !== 'string' || containerSelector.length < 1) {
        console.warn("replaceNodesInsideContainer(containerSelector, nodeList): typeof containerSelector !== 'string' || containerSelector.length < 1)");
        return;
    }

    const container = document.querySelector(containerSelector);
    if (!(container)) {
        console.warn("replaceNodesInsideContainer(containerSelector, nodeList): !(container)");
        return;
    }

    container.innerHTML = '';
    nodeList.forEach(node => {
        container.insertAdjacentElement('beforeend', node);
    });
}
function collapsibleDescription() {
    if (!!document.querySelector('.featured-product--mobile-description')) {
        let featuredProductDescriptionWrapper = document.querySelector('.featured-product--mobile-description');
        if (!!featuredProductDescriptionWrapper.querySelectorAll('.featured-product-description-buttons')) {
            let featuredProductDescriptionButtons = featuredProductDescriptionWrapper.querySelectorAll('.featured-product-description-buttons');
            if (!!featuredProductDescriptionWrapper.querySelector('.featured-product-description')) {
                let featuredProductDescription = featuredProductDescriptionWrapper.querySelector('.featured-product-description');
                featuredProductDescriptionButtons.forEach(descriptionButton =>{
                    descriptionButton.addEventListener('click', element => {
                        if (element.target.getAttribute('aria-show') === 'true') {
                            featuredProductDescription.setAttribute('aria-hidden', false);
                            if (!!featuredProductDescriptionWrapper.querySelector('.read-more')) {
                                featuredProductDescriptionWrapper.querySelector('.read-more').classList.add('hidden');
                            }
                            if (!!featuredProductDescriptionWrapper.querySelector('.show-less')) {
                                featuredProductDescriptionWrapper.querySelector('.show-less').classList.remove('hidden');
                            }
                        }else {
                            featuredProductDescription.setAttribute('aria-hidden', true);
                            if (!!featuredProductDescriptionWrapper.querySelector('.show-less')) {
                                featuredProductDescriptionWrapper.querySelector('.show-less').classList.add('hidden');
                            }
                            if (!!featuredProductDescriptionWrapper.querySelector('.read-more')) {
                                featuredProductDescriptionWrapper.querySelector('.read-more').classList.remove('hidden');
                            }
                        }
                    })
    
                })
            }
        }
    }
}
document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname.includes('collections')) {
        const nodes = getProductsWithOrder();
        const sortedNodes = sortNodesByOrder(nodes);
        replaceNodesInsideContainer(`${selectors.featuredCollection} ${selectors.productList}`, sortedNodes);
    }

    collapsibleDescription()
});